// import another component
import classes from './style.css'
import Main from './js/Main.js'

const main = new Main()
main.run()